// extracted by mini-css-extract-plugin
export default {"TeamList":"TeamList_TeamList__+0wtg","listContainer":"TeamList_listContainer__i5jl9","teamListHeader":"TeamList_teamListHeader__y2CFA","section":"TeamList_section__Z2EOy"};